const lang={
  gzjq:'Market Holiday',
  xgsc:'Hong Kong Market',
  xgscs:'Hong Kong',
  mgsc:'U.S. Market',
  xjps:'Singapore',
  mgscs:'U.S.',
  china:'China Holiday',
  chinas:'China',
  xjp:'Singapore Holiday',
  xjp:'Singapore',
  ja:'Japan Holiday',
  az:'Australia Holiday',
  tw:'Taiwan Holiday',
  d_g:'Germany Stocks',
  dg:'Germany',
  ml:'Malaysia Holiday',
  china_c:'China',
  xjp_c:'Singapore',
  ja_c:'Japan',
  az_c:'Australia',
  tw_c:'Taiwan',
  ml_c:'Malaysia',
  xg:'Hong Kong',
  am:'USA',
  grzh:'Individual Account',
  gszh:'Corporate Account',
  wtlb:'Problem category',
  sswt:'Search questions',
  yhmc:'Bank Name',
  zhhm:'Account Number / Type of Currency',
  swif:'SWIFT Code',
  addre:'Branch Address',
  zhmc:'Account Name',//Account name
  xggp:'Hong Kong Securities',
  scjs:'Market Introduction',
  jyfs:'Trading Information',
  fwsf:'Services Fees',
  jytg:'Trading Announcement',
  jytgs:'Latest Announcements',
  gstg:'Company notice',
  jtzb:'Group headquarters',
  lxwm:'Contact us',
  ybcx:'General query',
  jyrx:'Transaction Hotline',
  mfndzx:'Free mainland special line',
  cz:'Fax',
  dy:'Email',
  bgsj:'Office hours',
  dtime:'9:00 am - 6:00 PM closed on Saturdays, Sundays and Hong Kong Public Holidays',
  zcgl:'Asset Management',
  glfw:'Management services',
  tzcl:'​​Investment Strategy',
  qmiswx:'QMIS Official WeChat',
  homes:'Home / Global Stocks',
  b_fimg:require('@/image/home/alld_en.png'),
  getimage:require('@/image/home/getimage_en.png'),
  hongd_img:require('@/image/honggu/downimg_en.png'),
  rq_date:'Date',
  rq_biaoti:'Announcement',
  hongd_img_model:require('@/image/home_model/downimg_en.png'),
  getimagemodel:require('@/image/home_model/get_en.png'),
  mzsm:'Disclaimer',
  qmisyeas:'© 2021 QMIS Financial Group',
  agree:'Agree',
  an_ree:'Disagree',
  Android:require('@/image/home/Android.png'),
  Android_s:require('@/image/home_s/Android.png'),
  mod_and:require('@/image/home_model/Android_en.png'),
  inSearch:'Search',
  isBack:'Back',
  jjfw:'Fund Services',
  jjcp:'Fund products',
  mggp:'US Stocks',
  xgrg:'IPO Subscriptions',
  xgrl:'IPO Calendar',
  xjpg:'Singapore Stocks',
  malxy:'Malaysia Stocks',
  aozg:'Australia Stocks',
  jagu:'Japan Stocks',
  twstk:'Taiwan Stocks',
  slgt:'Stock Connect',
  zqfw:'Bonds Services',
  gpzc:'Stock Transfer',
  klzh:'Account Opening',
  tckx:'Deposit & Withdrawal',
  qlkh:'Apply In Person',
  ydkh:'Sent By Post',
  yykh:'Appointment',
  zxkh:'Account Opening APP',
  wskh:'Account Opening Online',
  sjfw:'Market Data Service',
  zjcq:'Deposit & Withdrawal',
  bgxz:'Download Form',
  cjwt:'FAQs',
  cn_login:'Online Trading',
  nYeat:'',//year
  ystk:'Privacy Data Policy',
  fxpl:'Risk Disclosure Statement',
  tkxz:'Terms & Conditions',
  clj:'Hyperlink Policy',
  aqts:'Security Tips & Advice',
  grsm:'Personal Data Collection Statement',
  ywjj:'Introduction',
  cpfw:'Products & Services',
  zsw:'There are no results matching your search "',
  cxss:'". Please search again.',
  ssjy:'Here are our search suggestions',
  y1:'Please check if your spelling is correct',
  y2:'Try more general words or fewer words',
  y3:'Try different keywords or synonyms',
  alb:'Search by category',
  Alert:'Fraudulent Alert',
  bew:'Beware of Fraudsters Posing as QMIS Financial Group',
  ithas:'It has come to our attention that fraudsters pose as QMIS Financial Group (the “Group”) to ask for the personal particulars and deposit money into their bank accounts in return for earning the commission under their fraudulent recruitment exercise.',
  ithas1:'The Group hereby advise you that the aforesaid fraudulent activities shall have nothing to do with the Group, nor any of its subsidiaries (including but not limited to QMIS Securities Limited and QMIS Asset Management Limited). You are further reminded not to make any payments to any third parties and disclose any sensitive information about yourselves and your bank accounts details.',
  ithas2:'Should you require any assistance, please report to the Police Station immediately or contact the 24-hour Anti-Scam Helpline of Anti-Deception Coordination Centre at 18222.',
  ithas3:'',
  qgp:'QMIS Financial Group',
  dapas:'11 March 2022',
  yuedu:'Read',

  zgdl: "China",
  zgxg: "Hong Kong,China",
  zgam: "Macau,China",
  adly: "Australia",
  jnd: "Canada",
  mlxy: "Malaysia",
  mg: "USA",
  xjp1: "Singapore",
  xxl: "New Zealand",
  yg: "UK",


  title_1:'Account Opening Appointment',
  title_2:'Thank you for using QMIS Securities account opening appointment service. Our staff will contact you to confirm the appointment details upon submission. Should you have any enquiries, please call our Customer Service Hotline (852) 3971 6919 or visit our headquarters.',
  title_3:'Personal Information',
  zwmc_yy:'English Name',
  cw_yy:'Title',
  dydz_yy:'Email Address',
  lldh_yy:'Telephone Number',

  title_4:'Appointment Details',
  yyrq_yy:'Appointment date',
  yysj_yy:'Appointment Time',
  yzm_yy:'Code',
  dj_yy:'Submit',


  // 11111

  home:'Home',
  whatWeDo:'What We Do',
  investment:'Investment Banking',
  global:'Global Securities',
  digital:'Digital Finance',
  asset:'Asset Management',
  wealth:'Wealth Management',
  financial:'Financial Leasing',
  newsEvents:'News & Events',
  aboutUs:'About Us',
  contactUs:'Contact Us',
  latest:'Latest Announcements',
  
  letUs:'Let Us Contact You',
  yourInfo:'Your Information',
  FirstName:'First Name',
  LastName:'Last Name',
  Email_bank:'Email',
  PhoneNumber:'Phone Number',
  Subject:'Subject',
  Account:'Account Opening',
  Careers:'Careers',
  Others:'Others',
  Comments:'Comments or Questions',
  Submit_bank:'Submit',

  Reminder:'Reminder',
  Submission:'Submission Completed',

  cookies1:'We use cookies to evaluate your use of the Website and to provide you with the best possible website experience. By continuing to browse this Website, you accept our use of cookies to collect data. For details, please refer to the Website\'s ',
  cookies2:'Privacy Data Policy',
  cookies3:'and',
  cookies4:'Personal Data Collection Statement',
  cookies5:'Confirm',


  BookFlights:'Book Flights',
  PleaseLeaveYour:'Please leave your contact details and filght request information, we will get back to you as soon as possible.',
  PersonalName:'Personal Name',
  CompanyName:'Company Name',
  Title:'Title',
  DateofBirth:'Date of Birth',
  PhoneNumber:'Phone Number',
  emailAddress:'E-mail Address',
  LeavingFrom:'Leaving From',
  GoingTo:'Going To',
  TripType:'Trip Type',
  CabinClassandPassengers:'Cabin Class and Passengers',
  DepartingOn:'Departing On',
  ReturningOn:'Returning On',
  SelectYour:'Select your travel dates',
  Remark:'Remark',
  PleaseEnter:'Please Enter',
  PleaseChoose:'Please Choose',
  Mr:'Mr',
  Mrs:'Mrs',
  Ms:'Ms',
  Miss:'Miss',
  Canada:'Canada',
  USA:'USA',
  Singapore:'Singapore',
  Countries:'Countries / Regions',
  Return:'Return',
  Oneway:'One way',
  SelectCabinClass:'Select cabin class and number of passengers',
  Class:'Class',
  First:'First',
  Business:'Business',
  PremiumEconomy:'Premium Economy',
  Economy:'Economy',
  BookingofMoreThan4:'Booking of more than 4 passengers is currently not available online. Please contact your local reservations office.',
  BookingofMoreThan9:'Booking of more than 9 passengers is currently not available online. Please contact your local reservations office.',
  Adults:'Adults (12+)',
  Children:'Children (2 to 11)',
  Infants:'Infants (under 2)',
  Done:'Done',
  MarketHoliday:'Market Holiday',
  Announcements:'Announcements',
  Date:'Date',
  Holiday:'Holiday',
  Day:'Day',
  Continue:'Continue',
  Back:'Back',
  
  
  Mar:'Mar',
  May:'May',
  Aug:'Aug',
  Oct:'Oct',
  Dec:'Dec',

  Mar1:'MAR',
  May1:'MAY',
  Aug1:'AUG',
  Oct1:'OCT',
  Dec1:'DEC',

  
  






  




}
export default lang;



// WEBPACK FOOTER //
// ./src/assets/eng.js